if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]') != undefined ? this.querySelector('[id^="QuickAddInfo-"]') : this.querySelector('.quick-add-modal__content-info');
        // console.log(this.modalContent)
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
          this.addEventListener('click', this.handleOutsideClick.bind(this));
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
       
      }
        handleOutsideClick(event) {
        // Get the modal dialog element
        const modalDialog = this.querySelector('[role="dialog"]');
        
        // Check if the click is outside the modal dialog but inside the modal backdrop
        if (modalDialog && !modalDialog.contains(event.target)) {
          // Close the modal
          this.hide();
        }
      }
      initQuickViewSlick() {
        const gallery = this.modalContent.querySelector(
          '.slider-mobile-gutter ul'
        );

        if (!gallery) return;

        const $gallery = window.jQuery(gallery);

        // Prevent double init
        if ($gallery.hasClass('slick-initialized')) return;

        // 🔴 Kill Shopify slider behavior
        gallery.classList.remove(
          'grid',
          'grid--peek',
          'slider',
          'slider--mobile'
        );

        gallery.style.display = 'block';

        // 🔥 Init Slick
        $gallery.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          dots: false,
          adaptiveHeight: false,
          mobileFirst: false,

          responsive: [
            {
              breakpoint: 650,
              settings: {
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 1040,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });

        // 🔥 Force layout recalculation
        setTimeout(() => {
          $gallery.slick('setPosition');
        }, 100);
      }


      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]') != undefined ? this.querySelector('[id^="QuickAddInfo-"]') : this.querySelector('.quick-add-modal__content-info');
        // console.log(this.modalContent)
            // console.log(this.modalContent)
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            super.show(opener);
            setTimeout(() => {
              this.initQuickViewSlick();
              // if(document.body.classList.contains("collection-custom-template") == true ){

              //   let optionsListoptions = document.querySelector(".option_list").querySelectorAll("input");
              //   if(optionsListoptions.length > 0){
              //     optionsListoptions.forEach((optionsListoption) => {
              //       // console.log(optionsListoption)
              //       if(optionsListoption.value == '10ml'){
              //         optionsListoption.click()
              //       }
              //     })
              //   }
              // }
             const buyNowButtons = document.querySelectorAll('.buy-now-button');

                if (!buyNowButtons.length) return;

                buyNowButtons.forEach(button => {
                  button.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Variant ID: closest form input
                    const form = button.closest('form');
                    if (!form) return;

                    const variantInput = form.querySelector('input[name="id"]');
                    if (!variantInput) return;

                    const variantId = variantInput.value;

                    // Quantity handling (Shopify compatible)
                    let quantity = 1;

                    const quantityInputWrapper = form.querySelector('quantity-input');
                    if (quantityInputWrapper) {
                      const qtyInput = quantityInputWrapper.querySelector('input');
                      if (qtyInput && qtyInput.value) {
                        quantity = parseInt(qtyInput.value, 10);
                      }
                    }

                    // Clear cart → add item → redirect to checkout
                    fetch('/cart/clear.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    })
                      .then(() => {
                        return fetch('/cart/add.js', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({
                            id: variantId,
                            quantity: quantity
                          })
                        });
                      })
                      .then(() => {
                        window.location.href = '/checkout';
                      })
                      .catch(error => {
                        console.error('Buy Now failed:', error);
                        alert('Something went wrong. Please try again.');
                      });
                  });
                });
           
            }, 300);

          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
